module.exports = __webpack_public_path__ + "img/status-1@3x.f43523a7.png";